<div>
  <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
    <p>
      {{ "module-assignment.femaleShirtAndShort.femaleShirtAndShortConfiguration" | translate }}
    </p>
    <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
      <mat-slide-toggle
        [(ngModel)]="status"
        id="ebasketSalesSetupFemaleShirtConfiguration"
        (change)="toggleEbasketFemaleShirtConfiguration()"
        [disabled]="action=='view'"
      >
      </mat-slide-toggle>
    </div>
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutGap="20px grid"
    *ngIf="status"
    class="u-margin-top-15 u-margin-bottom-15"
  >
    <div fxFlex="100">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ "module-assignment.femaleShirtAndShort.Badges" | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
          >
            <div fxFlex="100" class="example-container mat-elevation-z8">
              <table
                mat-table
                #ebasketFemaleBadgesTable
                [dataSource]="femaleBadgeDataSource"
                matSort
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="Female_BADGE">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.itemName" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.Female_BADGE }}</td>
                </ng-container>
                <ng-container matColumnDef="SKU_selection">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.SKU_selection" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{displayName(element)}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="badgeUrl">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.badgeURL" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.badgeUrl}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="logoUrl">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.logoURL" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.logoUrl}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.shirtPrint.action" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      [matTooltip]="'module-assignment.shirtPrint.edit' | translate"
                      matTooltipPosition="above"
                      (click)="openFemaleBedgesDialog(element)"
                      [disabled]="action=='view'"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      [matTooltip]="'module-assignment.shirtPrint.delete' | translate"
                      matTooltipPosition="above"
                      (click)="removeRow(element)"
                      [disabled]="action=='view'"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: productColumns;"></tr>
              </table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div
    fxLayout="row wrap"
    fxLayoutGap="20px grid"
    *ngIf="status"
    class="u-margin-top-15 u-margin-bottom-15"
  >
    <div fxFlex="100">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ "module-assignment.femaleShirtAndShort.name_and_number" | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
          >
            <div fxFlex="100" class="example-container mat-elevation-z8">
              <table
                mat-table
                #ebasketFemaleNameAndNumbersTable
                [dataSource]="femaleNameAndNumbers"
                matSort
              >
                <ng-container matColumnDef="FEMALE_NAME_AND_NUMBER">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.itemName" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.FEMALE_NAME_AND_NUMBER }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="name_SKU_selection">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.name_SKU_selection" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.name_SKU_selection}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="number_SKU_selection">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.femaleShirtAndShort.number_SKU_selection" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.number_SKU_selection}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.shirtPrint.action" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      mat-icon-button
                      [matTooltip]="'module-assignment.shirtPrint.edit' | translate"
                      matTooltipPosition="above"
                      (click)="openAddNameAndNumberDialog(element)"
                      [disabled]="action=='view'"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      [matTooltip]="'module-assignment.shirtPrint.delete' | translate"
                      matTooltipPosition="above"
                      (click)="removeNameAndNumberRow(element)"
                      [disabled]="action=='view'"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="nameAndNumbersColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: nameAndNumbersColumns;"></tr>
              </table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
